(function () {
  'use strict';

  var STORAGE_KEY = 'quotecart_items';
  var PROXY_URL = 'https://crm-relay.torchstar.us/api/inquiry';
  var DRAWER_OPEN_CLASS = 'is-open';

  // ── State management ──────────────────────────────────
  function getItems() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateUI();
  }
  function addItem(item) {
    var items = getItems();
    var key = item.product_handle + ':' + (item.variant_id || '');
    var existing = items.findIndex(function (i) {
      return (i.product_handle + ':' + (i.variant_id || '')) === key;
    });
    if (existing >= 0) {
      items[existing].quantity = (items[existing].quantity || 1) + (item.quantity || 1);
    } else {
      items.push(item);
    }
    saveItems(items);
    return existing >= 0 ? 'updated' : 'added';
  }
  function removeItem(index) {
    var items = getItems();
    items.splice(index, 1);
    saveItems(items);
  }
  function updateQuantity(index, qty) {
    var items = getItems();
    if (items[index]) {
      items[index].quantity = Math.max(1, qty);
      saveItems(items);
    }
  }
  function clearAll() { saveItems([]); }

  // ── UI updates ────────────────────────────────────────
  function updateUI() {
    var items = getItems();
    var count = items.length;

    // Floating badge
    document.querySelectorAll('[data-quote-count]').forEach(function (el) {
      if (count > 0) { el.textContent = count; el.style.display = ''; }
      else { el.style.display = 'none'; }
    });

    // Header count
    var countText = document.querySelector('[data-quote-count-text]');
    var countLabel = document.querySelector('[data-quote-count-label]');
    if (countText) countText.textContent = count;
    if (countLabel) countLabel.textContent = count === 1 ? 'item' : 'items';

    // Toggle empty / content
    var emptyEl = document.getElementById('quoteDrawerEmpty');
    var contentEl = document.getElementById('quoteDrawerContent');
    if (emptyEl) emptyEl.style.display = count === 0 ? '' : 'none';
    if (contentEl) contentEl.style.display = count > 0 ? '' : 'none';

    // Submit text
    var submitText = document.querySelector('.qc-form-submit-text');
    if (submitText) {
      submitText.textContent = count > 0 ? 'Submit Quote Request' : 'Submit Inquiry';
    }

    // Add to Quote button label toggle
    document.querySelectorAll('.quote-add-trigger').forEach(function (btn) {
      if (btn.classList.contains('is-added')) return;
      var label = btn.querySelector('.btn-text') || btn;
      label.textContent = count > 0 ? 'Add to Quote' : 'Request a Quote';
    });

    renderItems(items);
  }

  function renderItems(items) {
    var container = document.getElementById('quoteDrawerItems');
    if (!container) return;
    var showPrice = window.__quoteShowPrice;

    var grandTotal = 0;
    var html = '<table class="qc-table"><thead><tr>' +
      '<th class="qc-th-img"></th>' +
      '<th class="qc-th-product">Product</th>' +
      '<th class="qc-th-qty">Qty</th>' +
      '<th class="qc-th-target">Target $</th>' +
      '<th class="qc-th-sub">Subtotal</th>' +
      '<th class="qc-th-del"></th>' +
      '</tr></thead><tbody>';

    items.forEach(function (item, idx) {
      var pTitle = item.product_title || 'Product';
      var qty = item.quantity || 1;
      var offerPrice = item.offer_price || '';
      var subtotal = offerPrice ? (parseFloat(offerPrice) * qty) : 0;
      if (subtotal) grandTotal += subtotal;
      var variantText = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var skuText = item.variant_sku ? 'SKU: ' + item.variant_sku : '';
      var meta = [variantText, skuText].filter(Boolean).join(' | ');

      html +=
        '<tr class="qc-row" data-qc-index="' + idx + '">' +
          '<td class="qc-td-img">' +
            (item.product_image ? '<img src="' + item.product_image + '" alt="" width="40" height="40" />' : '') +
          '</td>' +
          '<td class="qc-td-product">' +
            '<div class="qc-product-name-wrap"><div class="qc-product-name-scroll"><a href="/products/' + escHtml(item.product_handle || '') + '">' + escHtml(pTitle) + '</a></div></div>' +
            (meta ? '<div class="qc-product-meta">' + escHtml(meta) + '</div>' : '') +
            (showPrice && item.variant_price ? '<div class="qc-product-meta">' + escHtml(item.variant_price) + '</div>' : '') +
          '</td>' +
          '<td class="qc-td-qty"><input class="qc-input-sm" type="number" value="' + qty + '" min="1" data-qc-qty-input="' + idx + '" /></td>' +
          '<td class="qc-td-target"><input class="qc-input-sm" type="number" value="' + offerPrice + '" min="0" step="0.01" placeholder="0" data-qc-offer="' + idx + '" /></td>' +
          '<td class="qc-td-sub">' + (subtotal ? '$' + subtotal.toFixed(2) : '-') + '</td>' +
          '<td class="qc-td-del"><a href="#" data-qc-remove="' + idx + '" title="Remove">&times;</a></td>' +
        '</tr>';
    });

    html += '</tbody></table>';
    container.innerHTML = html;

    // Update header total
    var totalEl = document.getElementById('quoteDrawerTotal');
    var totalValEl = document.getElementById('quoteDrawerTotalValue');
    var clearBtn = document.getElementById('quoteDrawerClearBtn');
    if (totalEl && totalValEl) {
      if (grandTotal > 0) { totalValEl.textContent = '$' + grandTotal.toFixed(2); totalEl.style.display = ''; }
      else { totalEl.style.display = 'none'; }
    }
    if (clearBtn) clearBtn.style.display = items.length > 0 ? '' : 'none';
  }

  function escHtml(str) {
    var d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  // ── Floating quote icon ────────────────────────────────
  function injectFloatingIcon() {
    if (document.getElementById('qcFloatContainer')) return;

    var container = document.createElement('div');
    container.id = 'qcFloatContainer';
    container.className = 'qc-float-container';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'qc-float-btn';
    btn.setAttribute('data-quote-cart-toggle', '');
    btn.setAttribute('aria-label', 'Quote List');
    btn.innerHTML =
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2"/>' +
        '<rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>' +
        '<line x1="9" y1="12" x2="15" y2="12"/>' +
        '<line x1="9" y1="16" x2="13" y2="16"/>' +
      '</svg>' +
      '<span class="qc-float-badge" data-quote-count style="display:none;">0</span>';

    container.appendChild(btn);
    document.body.appendChild(container);
  }

  // ── Drawer open / close ───────────────────────────────
  function openDrawer() {
    var drawer = document.getElementById('quoteCartDrawer');
    if (!drawer) return;
    updateUI();

    // Calculate and set scrollbar width to prevent layout shift
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--qc-scrollbar-width', scrollbarWidth + 'px');

    drawer.classList.add(DRAWER_OPEN_CLASS);
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('qc-modal-open');
  }
  function closeDrawer() {
    var drawer = document.getElementById('quoteCartDrawer');
    if (!drawer) return;
    drawer.classList.remove(DRAWER_OPEN_CLASS);
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('qc-modal-open');
  }

  // ── Handle Add to Quote ───────────────────────────────
  function handleAddToQuote(trigger) {
    var title = trigger.getAttribute('data-product-title') || '';
    var handle = trigger.getAttribute('data-product-handle') || '';
    var image = trigger.getAttribute('data-product-image') || '';
    var productId = trigger.getAttribute('data-product-id') || '';
    var variantId = trigger.getAttribute('data-variant-id') || '';
    var variantTitle = trigger.getAttribute('data-variant-title') || '';
    var variantSku = trigger.getAttribute('data-variant-sku') || '';
    var variantPrice = trigger.getAttribute('data-variant-price') || '';
    var variantPriceCents = parseInt(trigger.getAttribute('data-variant-price-cents'), 10) || 0;
    var vendor = trigger.getAttribute('data-vendor') || '';

    // If it's on the product detail page (PDP), read current variant from form
    // and look up full variant data from the embedded JSON
    if (trigger.getAttribute('data-pdp') === 'true') {
      var pdpForm = document.querySelector('form[action="/cart/add"] select[name="id"], form[action="/cart/add"] input[name="id"]');
      if (pdpForm && pdpForm.value) {
        variantId = pdpForm.value;

        // Look up full variant data from wrapper's data-json-product
        var wrapper = trigger.closest('[data-json-product]');
        if (wrapper) {
          try {
            var pd = JSON.parse(wrapper.getAttribute('data-json-product'));
            if (pd.variants) {
              var v = pd.variants.find(function (x) { return String(x.id) === String(variantId); });
              if (v) {
                variantTitle = (v.title && v.title !== 'Default Title') ? v.title : variantTitle;
                variantSku = v.sku || variantSku;
                if (v.price) {
                  variantPriceCents = v.price;
                  variantPrice = '$' + (v.price / 100).toFixed(2);
                }
              }
            }
          } catch (e) { /* ignore */ }
        }
      }
    }

    var result = addItem({
      product_title: title,
      product_handle: handle,
      product_image: image,
      product_id: productId,
      vendor: vendor,
      variant_title: variantTitle,
      variant_sku: variantSku,
      variant_price: variantPrice,
      variant_price_cents: variantPriceCents,
      variant_id: variantId,
      quantity: 1,
    });

    // Button feedback
    var label = trigger.querySelector('.btn-text') || trigger;
    var origText = label.textContent;
    label.textContent = result === 'updated' ? 'Updated \u2713' : 'Added \u2713';
    trigger.classList.add('is-added');
    setTimeout(function () {
      label.textContent = origText;
      trigger.classList.remove('is-added');
    }, 1500);

    // Trigger pulse + fly animation together (independent)
    triggerCartFeedback(trigger, image);
  }

  // ── Cart feedback: subtle pulse on the floating icon ──
  function triggerCartFeedback(trigger, imageSrc) {
    var target = document.querySelector('.qc-float-btn');
    if (!target) return;
    target.classList.remove('qc-float-pulse');
    void target.offsetWidth; // force reflow to restart animation
    target.classList.add('qc-float-pulse');
    setTimeout(function () { target.classList.remove('qc-float-pulse'); }, 800);
  }

  // ── Fly-to-cart animation ─────────────────────────────
  function flyImageToCart(trigger, imageSrc, target) {
    if (!target) target = document.querySelector('.qc-float-btn');
    if (!target) return;

    // Find the product card's image as source
    var card = trigger.closest('.product-card') || trigger.closest('.card');
    var sourceImg = card ? card.querySelector('img') : null;
    var srcRect;

    if (sourceImg) {
      srcRect = sourceImg.getBoundingClientRect();
    } else {
      srcRect = trigger.getBoundingClientRect();
    }

    var targetRect = target.getBoundingClientRect();
    var startX = srcRect.left + srcRect.width / 2 - 40;
    var startY = srcRect.top + srcRect.height / 2 - 40;
    var endX = targetRect.left + targetRect.width / 2 - 40;
    var endY = targetRect.top + targetRect.height / 2 - 40;
    var dx = endX - startX;
    var dy = endY - startY;

    // Create ghost element with all inline styles
    var ghost = document.createElement('div');
    ghost.style.cssText =
      'position:fixed;z-index:2147483647;pointer-events:none;' +
      'width:80px;height:80px;border-radius:8px;' +
      'left:' + startX + 'px;top:' + startY + 'px;' +
      'background:' + (imageSrc ? 'url(' + imageSrc + ') center/cover no-repeat #fff' : '#ddd') + ';' +
      'box-shadow:0 8px 24px rgba(0,0,0,0.3);' +
      'border:2px solid #fff;';

    document.body.appendChild(ghost);

    // Use Web Animations API for reliable animation
    if (ghost.animate) {
      ghost.animate([
        { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
        { transform: 'translate(' + (dx * 0.5) + 'px,' + (dy * 0.3) + 'px) scale(0.7) rotate(180deg)', opacity: 0.9, offset: 0.5 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.15) rotate(360deg)', opacity: 0, offset: 1 }
      ], {
        duration: 700,
        easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
        fill: 'forwards'
      });
    } else {
      // Fallback for old browsers
      ghost.style.transition = 'transform 0.7s cubic-bezier(0.4,0,0.2,1), opacity 0.7s ease';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          ghost.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.15)';
          ghost.style.opacity = '0';
        });
      });
    }

    setTimeout(function () { ghost.remove(); }, 720);
  }

  // ── Form submission ───────────────────────────────────
  function handleFormSubmit(e) {
    e.preventDefault();
    var form = e.target;

    var hp = form.querySelector('[name="hp_email"]');
    if (hp && hp.value) return;

    var emailInput = form.querySelector('[name="email"]');
    var firstInput = form.querySelector('[name="first_name"]');
    var lastInput = form.querySelector('[name="last_name"]');
    var errorEl = document.getElementById('quoteDrawerError');

    form.querySelectorAll('.is-invalid').forEach(function (el) { el.classList.remove('is-invalid'); });
    if (errorEl) errorEl.style.display = 'none';

    var errors = [];
    if (!firstInput.value.trim()) { firstInput.classList.add('is-invalid'); errors.push('First name required'); }
    if (!lastInput.value.trim()) { lastInput.classList.add('is-invalid'); errors.push('Last name required'); }
    if (!emailInput.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value)) {
      emailInput.classList.add('is-invalid'); errors.push('Valid email required');
    }
    if (errors.length) {
      if (errorEl) { errorEl.textContent = errors[0]; errorEl.style.display = ''; }
      return;
    }

    var items = getItems();
    var products = items.map(function (item) {
      return {
        title: item.product_title,
        variant_title: item.variant_title,
        sku: item.variant_sku,
        handle: item.product_handle,
        image: item.product_image,
        price: item.variant_price,
        price_cents: item.variant_price_cents || 0,
        product_id: item.product_id || '',
        variant_id: item.variant_id || '',
        vendor: item.vendor || '',
        quantity: item.quantity || 1,
        offer_price: item.offer_price || null,
      };
    });

    var payload = {
      customer: {
        first_name: firstInput.value.trim(),
        last_name: lastInput.value.trim(),
        email: emailInput.value.trim(),
        phone: (form.querySelector('[name="phone"]') || {}).value || '',
        company: (form.querySelector('[name="company"]') || {}).value || '',
        message: (form.querySelector('[name="message"]') || {}).value || '',
      },
      products: products,
      source: products.length ? 'quote_cart' : 'general',
      hp_email: '',
    };

    var btn = form.querySelector('.qc-form-submit');
    btn.disabled = true;
    btn.querySelector('.qc-form-submit-text').style.display = 'none';
    btn.querySelector('.qc-form-submit-loading').style.display = '';

    fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (resp) {
        if (resp.ok) return resp.json();
        return resp.json().then(function (d) { throw new Error(d.message || 'Submission failed'); });
      })
      .then(function () {
        clearAll();
        form.reset();
        document.getElementById('quoteDrawerSuccess').style.display = '';
        var body = document.querySelector('#quoteCartDrawer .qc-sidebar__body');
        var header = document.querySelector('#quoteCartDrawer .qc-sidebar__header');
        if (body) body.style.display = 'none';
        setTimeout(function () {
          closeDrawer();
          setTimeout(function () {
            document.getElementById('quoteDrawerSuccess').style.display = 'none';
            if (body) body.style.display = '';
            btn.disabled = false;
            btn.querySelector('.qc-form-submit-text').style.display = '';
            btn.querySelector('.qc-form-submit-loading').style.display = 'none';
            updateUI();
          }, 500);
        }, 2500);
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message || 'Failed to submit.'; errorEl.style.display = ''; }
        btn.disabled = false;
        btn.querySelector('.qc-form-submit-text').style.display = '';
        btn.querySelector('.qc-form-submit-loading').style.display = 'none';
      });
  }

  // ── Event delegation ──────────────────────────────────
  function bindEvents() {
    document.addEventListener('click', function (e) {
      var t;

      if ((t = e.target.closest('[data-pc-pill]'))) {
        e.preventDefault();
        handlePillClick(t);
        return;
      }
      if ((t = e.target.closest('.quote-add-trigger'))) {
        e.preventDefault();
        handleAddToQuote(t);
        return;
      }
      if (e.target.closest('[data-quote-cart-toggle]')) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest('[data-quote-drawer-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      if ((t = e.target.closest('[data-qc-remove]'))) {
        e.preventDefault();
        removeItem(parseInt(t.getAttribute('data-qc-remove'), 10));
        return;
      }
      if (e.target.closest('[data-qc-clear-all]')) {
        clearAll();
        return;
      }
    });

    document.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-qc-qty-input]');
      if (inp) updateQuantity(parseInt(inp.getAttribute('data-qc-qty-input'), 10), parseInt(inp.value, 10) || 1);

      var offerInp = e.target.closest('[data-qc-offer]');
      if (offerInp) {
        var oi = parseInt(offerInp.getAttribute('data-qc-offer'), 10);
        var items = getItems();
        if (items[oi]) {
          items[oi].offer_price = parseFloat(offerInp.value) || 0;
          saveItems(items);
        }
      }
    });

    var form = document.getElementById('quoteDrawerFormEl');
    if (form) form.addEventListener('submit', handleFormSubmit);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var drawer = document.getElementById('quoteCartDrawer');
        if (drawer && drawer.classList.contains(DRAWER_OPEN_CLASS)) closeDrawer();
      }
    });
  }

  // ── Product card variant pills ─────────────────────────
  function getCardVariants(card) {
    try {
      var json = card.getAttribute('data-json-product');
      if (!json) return [];
      return JSON.parse(json).variants || [];
    } catch (e) { return []; }
  }
  function getCardSelectedOptions(card) {
    var opts = [];
    card.querySelectorAll('[data-pc-option]').forEach(function (group) {
      var active = group.querySelector('[data-pc-pill].is-active');
      if (active) opts.push(active.getAttribute('data-option-value'));
    });
    return opts;
  }
  function findCardVariant(variants, selectedOpts) {
    return variants.find(function (v) {
      return v.options && v.options.every(function (opt, i) { return selectedOpts[i] === opt; });
    });
  }

  function updateCardAvailability(card, skipIdx) {
    var variants = getCardVariants(card);
    card.querySelectorAll('[data-pc-option]').forEach(function (group) {
      var gi = parseInt(group.getAttribute('data-option-index'), 10);
      if (gi === skipIdx) return;

      var currentOpts = getCardSelectedOptions(card);
      var availableVals = [];
      variants.forEach(function (v) {
        if (!v.options) return;
        var valid = true;
        currentOpts.forEach(function (opt, oi) {
          if (oi === gi) return;
          if (v.options[oi] !== opt) valid = false;
        });
        if (valid) availableVals.push(v.options[gi]);
      });

      group.querySelectorAll('[data-pc-pill]').forEach(function (p) {
        var val = p.getAttribute('data-option-value');
        if (availableVals.indexOf(val) >= 0) {
          p.classList.remove('is-unavailable');
          p.disabled = false;
        } else {
          p.classList.add('is-unavailable');
          p.disabled = true;
          if (p.classList.contains('is-active')) {
            p.classList.remove('is-active');
            var firstAvail = group.querySelector('[data-pc-pill]:not(.is-unavailable)');
            if (firstAvail) firstAvail.classList.add('is-active');
          }
        }
      });
    });
  }

  function syncCardVariant(card) {
    var variants = getCardVariants(card);
    var selectedOpts = getCardSelectedOptions(card);
    var matched = findCardVariant(variants, selectedOpts);
    if (!matched) return;

    // Update form variant ID input (for Add to Cart)
    card.querySelectorAll('[data-pc-variant-id]').forEach(function (input) {
      input.value = matched.id;
    });

    // Update Add to Quote button data attributes
    card.querySelectorAll('.quote-add-trigger').forEach(function (btn) {
      btn.setAttribute('data-variant-id', String(matched.id));
      btn.setAttribute('data-variant-title', matched.title || '');
      btn.setAttribute('data-variant-sku', matched.sku || '');
      if (matched.price) {
        btn.setAttribute('data-variant-price', '$' + (matched.price / 100).toFixed(2));
        btn.setAttribute('data-variant-price-cents', String(matched.price));
      }
    });
  }

  function initCardVariants() {
    document.querySelectorAll('.product-card[data-json-product]').forEach(function (card) {
      var groups = card.querySelectorAll('[data-pc-option]');
      if (groups.length > 1) {
        updateCardAvailability(card, -1);
      }
      syncCardVariant(card);
    });
  }

  function handlePillClick(pill) {
    var optionGroup = pill.closest('[data-pc-option]');
    if (!optionGroup || pill.disabled) return;

    optionGroup.querySelectorAll('[data-pc-pill]').forEach(function (p) { p.classList.remove('is-active'); });
    pill.classList.add('is-active');

    var card = pill.closest('.product-card');
    if (!card) return;

    var clickedIdx = parseInt(optionGroup.getAttribute('data-option-index'), 10);
    updateCardAvailability(card, clickedIdx);
    syncCardVariant(card);
  }

  // ── Hijack #ask-for-quote / [data-afq-open] links ────
  function hijackAskForQuoteLinks() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href="#ask-for-quote"], a[href*="#ask-for-quote"], [data-afq-open]');
      if (link) {
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
      }
    }, true); // capture phase to intercept before existing modal handlers
  }

  // ── Direct close handlers (bypass document delegation) ──
  function bindDirectCloseHandlers() {
    var drawer = document.getElementById('quoteCartDrawer');
    if (!drawer) return;
    drawer.querySelectorAll('[data-quote-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      });
    });
  }

  // ── Init ──────────────────────────────────────────────
  function init() {
    injectFloatingIcon();
    hijackAskForQuoteLinks();
    initCardVariants();
    updateUI();
    bindEvents();
    bindDirectCloseHandlers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
